function initComparisons() {
  var overlays = document.getElementsByClassName("img-comp-overlay");
  
  for (var i = 0; i < overlays.length; i++) {
    compareImages(overlays[i]);
  }
  
  function compareImages(overlay) {
    var slider, clicked = 0;
    var container = overlay.parentElement;
    var w = container.offsetWidth;
    
    // Set initial position to 50%
    overlay.style.width = (w / 2) + "px";
    
    slider = container.getElementsByClassName("img-comp-slider")[0];
    if (!slider) return;
    
    // Position slider initially
    slider.style.left = (w / 2) + "px";
    
    // Mouse events
    slider.addEventListener("mousedown", slideReady);
    window.addEventListener("mouseup", slideFinish);
    
    // Touch events
    slider.addEventListener("touchstart", slideReady);
    window.addEventListener("touchend", slideFinish);
    
    function slideReady(e) {
      e.preventDefault();
      clicked = 1;
      window.addEventListener("mousemove", slideMove);
      window.addEventListener("touchmove", slideMove);
    }
    
    function slideFinish() {
      clicked = 0;
      window.removeEventListener("mousemove", slideMove);
      window.removeEventListener("touchmove", slideMove);
    }
    
    function slideMove(e) {
      if (clicked == 0) return;
      var pos = getCursorPos(e);
      slide(pos);
    }
    
    function getCursorPos(e) {
      e = e || window.event;
      var rect = container.getBoundingClientRect();
      var x = 0;
      
      // Get the mouse/touch position
      if (e.type.indexOf('touch') !== -1) {
        x = e.touches[0].clientX;
      } else {
        x = e.clientX;
      }
      
      // Calculate position relative to container
      x = x - rect.left;
      
      // Constrain to container bounds
      if (x < 0) x = 0;
      if (x > w) x = w;
      
      return x;
    }
    
    function slide(x) {
      overlay.style.width = x + "px";
      slider.style.left = x + "px";
    }
    
    // Handle window resize
    window.addEventListener('resize', function() {
      w = container.offsetWidth;
      var currentPercent = parseFloat(overlay.style.width) / w * 100;
      overlay.style.width = (w * currentPercent / 100) + "px";
      slider.style.left = overlay.style.width;
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComparisons);
} else {
  initComparisons();
}

// Re-initialize on Shopify section load
document.addEventListener('shopify:section:load', function() {
  setTimeout(initComparisons, 100);
});
